/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_InInputs */

const en_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

const fr_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom avant`)
};

const de_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößern`)
};

const it_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci`)
};

const ru_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить масштаб`)
};

const es_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dar un golpe de zoom`)
};

const zh_cn2_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大`)
};

const ja_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームイン`)
};

const hi_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम इन`)
};

const pt_pt2_zoom_in = /** @type {(inputs: Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar`)
};

/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Zoom_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_in = /** @type {((inputs?: Zoom_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_zoom_in(inputs)
	if (locale === "de") return de_zoom_in(inputs)
	if (locale === "it") return it_zoom_in(inputs)
	if (locale === "ru") return ru_zoom_in(inputs)
	if (locale === "es") return es_zoom_in(inputs)
	if (locale === "zh-CN") return zh_cn2_zoom_in(inputs)
	if (locale === "ja") return ja_zoom_in(inputs)
	if (locale === "hi") return hi_zoom_in(inputs)
	if (locale === "pt-PT") return pt_pt2_zoom_in(inputs)
	return en_zoom_in(inputs)
});